(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/Messages"] = factory();
	else
		root["@makolab/library-react/dist/Messages"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 246);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/withEventService");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("lodash/isFunction");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "styles", function() { return styles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Messages", function() { return Messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_SnackbarContent__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_SnackbarContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_SnackbarContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_slice__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isFunction__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commons_with_event_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commons_with_event_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__commons_with_event_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__messages_jss_js__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_icon_icon__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_icon_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_icon_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__messages_types__ = __webpack_require__(77);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * @module @makolab/library-react/build/Messages
 */var styles=__WEBPACK_IMPORTED_MODULE_12__messages_jss_js__["a" /* default */];var Messages=function(_Component){_inherits(Messages,_Component);function Messages(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Messages);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Messages.__proto__||Object.getPrototypeOf(Messages)).call.apply(_ref,[this].concat(args))),_this),_this.state={queue:_this.props.queue,display:null},_this.componentDidMount=function(){var _this$props=_this.props,eventService=_this$props.eventService,addMessageEventName=_this$props.addMessageEventName;eventService.registerEventName(addMessageEventName).on(eventService.getEvent(addMessageEventName),_this.addMessageToQueue);_this.moveFromQueueToDisplay();},_this.componentWillUnmount=function(){var _this$props2=_this.props,eventService=_this$props2.eventService,addMessageEventName=_this$props2.addMessageEventName;eventService.off(eventService.getEvent(addMessageEventName),_this.addMessageToQueue);},_this.addMessageToQueue=function(message){var queue=[].concat(_toConsumableArray(_this.props.queue));// TODO: add some prop-types validation?
queue.push(message);_this.setState({queue:queue},function(){_this.moveFromQueueToDisplay();});},_this.moveFromQueueToDisplay=function(){var queue=_this.state.queue;if(queue.length===0){_this.setState({queue:[],display:null});return;}var tmpQueue=__WEBPACK_IMPORTED_MODULE_8_lodash_slice___default()(queue,0,1);var newQueue=__WEBPACK_IMPORTED_MODULE_8_lodash_slice___default()(queue,1);var newDisplay=tmpQueue[0]?Object.assign({},tmpQueue[0]):null;if(newDisplay&&__WEBPACK_IMPORTED_MODULE_9_lodash_isUndefined___default()(newDisplay.open)){newDisplay.open=true;}_this.setState({queue:newQueue,display:newDisplay});},_this.handleClose=function(message){return function(){var display=Object.assign({},message,{open:false});_this.setState({display:display},function(){if(__WEBPACK_IMPORTED_MODULE_10_lodash_isFunction___default()(message.onClose)){message.onClose();}});};},_this.handleExited=function(message){return function(){_this.setState({display:null},function(){_this.moveFromQueueToDisplay();if(__WEBPACK_IMPORTED_MODULE_10_lodash_isFunction___default()(message.onExited)){message.onExited();}});};},_this.renderContent=function(props,message){var classes=props.classes,closeIconId=props.closeIconId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_SnackbarContent___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes[message.variant||'info'],message.className),'aria-describedby':'client-snackbar',message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.message},message.iconId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_icon_icon___default.a,{id:message.iconId,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.icon)}),message.message),action:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default.a,{key:'close','aria-label':'Close',color:'inherit',className:classes.close,onClick:_this.handleClose(message)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_icon_icon___default.a,{id:closeIconId,className:classes.actionIcon}))]});},_this.render=function(){var _this$props3=_this.props,classes=_this$props3.classes,anchorOrigin=_this$props3.anchorOrigin,autoHideDuration=_this$props3.autoHideDuration,ClickAwayListenerProps=_this$props3.ClickAwayListenerProps,disableWindowBlurListener=_this$props3.disableWindowBlurListener;var display=_this.state.display;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root)},display&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default.a,Object.assign({},display,{anchorOrigin:anchorOrigin,autoHideDuration:autoHideDuration,disableWindowBlurListener:disableWindowBlurListener,ClickAwayListenerProps:ClickAwayListenerProps,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.snackbar),onClose:_this.handleClose(display),onExited:_this.handleExited(display)}),_this.renderContent(_this.props,display)));},_temp),_possibleConstructorReturn(_this,_ret);}return Messages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Messages.displayName='Messages';Messages.propTypes={/** initial queue, used only once on component did mount */queue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ContentProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,variant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['error','warning','info','success']),className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,iconId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),ClickAwayListenerProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,disableWindowBlurListener:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,eventService:__WEBPACK_IMPORTED_MODULE_11__commons_with_event_service__["PROP_TYPE_EVENT_SERVICE"],addMessageEventName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,anchorOrigin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({horizontal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left','center','right']),vertical:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top','bottom'])}),autoHideDuration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,closeIconId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Messages.defaultProps={addMessageEventName:__WEBPACK_IMPORTED_MODULE_14__messages_types__["EVENT_ADD_MASSAGE"],disableWindowBlurListener:false,ClickAwayListenerProps:{},queue:[],anchorOrigin:{horizontal:'right',vertical:'bottom'},autoHideDuration:6000,closeIconId:'close'};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_7_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles),__WEBPACK_IMPORTED_MODULE_11__commons_with_event_service___default()({name:'eventService'})])(Messages));

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/SnackbarContent");

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_green__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_green___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_green__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_amber__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_amber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_amber__);
// TODO: move status colors to theme?
/**
 * [Material UI theme documentation]{@link https://material-ui.com/customization/themes/}
 * [Material UI default theme object]{@link https://material-ui.com/customization/default-theme/}
 * @param {Object} theme - Material UI theme object
 * @returns {Object} - custom jss styles object
 *//* harmony default export */ __webpack_exports__["a"] = (function(theme){return{root:{},snackbar:{},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0__material_ui_core_colors_green___default.a[600]},error:{backgroundColor:theme.palette.error.dark},info:{backgroundColor:theme.palette.primary.dark},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__material_ui_core_colors_amber___default.a[700]},icon:{marginRight:theme.spacing.unit},actionIcon:{},message:{display:'flex',alignItems:'center'}};});

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/colors/green");

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/colors/amber");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/IconButton");

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = require("lodash/isUndefined");

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = require("lodash/slice");

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Snackbar");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/Icon");

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_ADD_MASSAGE", function() { return EVENT_ADD_MASSAGE; });
/**
 * @desc default event name for adding messages
 * @type {string}
 */var EVENT_ADD_MASSAGE="MLB_MESSAGES/ADD_MESSAGE";

/***/ })

/******/ });
});
//# sourceMappingURL=Messages.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/Messages.js
// module id = 656
// module chunks = 6